module.exports = __webpack_public_path__ + "img/case_opening_background_1.744bde2f.png";